<template>
	<el-row>
		<el-form ref="info" :model="info" label-position="right" label-width="90px">
			<el-form-item label="公告名称:" prop="name" :rules="[{
           required: true, message: '请输入公告名称', trigger: 'blur'
      }]">
				<el-input v-model="info.name"></el-input>
			</el-form-item>
			<el-form-item label="描述:" prop="describes" :rules="[{
           required: true, message: '请输入描述', trigger: 'blur'
      }]">
				<wangeditor v-model="info.describes" />
			</el-form-item>
			<el-form-item>
				<el-button @click="queren" type="primary">确认</el-button>
			</el-form-item>
		</el-form>
	</el-row>
</template>

<script>
	import wangeditor from "../../../components/wangEditor/wangEditor.vue";
	export default {
		components: {
			wangeditor,
		},
		data() {
			return {
				info: {
					name: "",
					describes: ''
				}
			}
		},
		methods: {
			queren() {
				this.$refs.info.validate((vai) => {
					if (vai) {
						if (this.$route.query.cz == "bj") {
							this.$http.post(`/api/course/ClrNoticeManageController/edit`, {
								"id": this.$route.query.id,
								"name": this.info.name,
								"describes": this.info.describes
							}).then(res => {
								console.log(res);
								if (res.data.status == 0) {
									this.$message.success(res.data.data)
									this.$router.push('./notice')
								} else {
									this.$message.error('编辑成功但数据未发生变化')
								}
							})
						} else if (this.$route.query.cz == "tj") {
							this.$http.post(`/api/course/ClrNoticeManageController/add`, {
								"name": this.info.name,
								"describes": this.info.describes
							}).then(res => {
								console.log(res.data);
								if (res.data.status == 0) {
									this.$message.success(res.data.data)
									this.$router.push('./notice')
								}
							})
						}

					}
				})
			}
		},
		created() {
			if (this.$route.query.cz == "bj") {
				this.info.name = this.$route.query.name
				this.info.describes = this.$route.query.describes
			} else if (this.$route.query.cz == "tj") {
				this.info.name = ''
				this.info.describes = ''
			}
		}
	}
</script>

<style scoped="scoped">

</style>
